// Interview Tips *************************************************************************
// pathname: /v1/interview/tips
// ************************************************************************************************
import { ApiGetInterviewTipsOk, useSwrApi } from 'src/hooks/useSwrApi';


// SWR: fetch interview tips
// usage: const { data, error, ... } = useSwrInterviewTips(locale);
// ********************************************
export const useSwrInterviewTips = (locale: string) => {
  // SWR: fetch data
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiGetInterviewTipsOk>({
    url: '/v1/interview/tips',
    locale,
    apiOptions: {
      revalidateOnFocus: false,
      dedupingInterval: 10000, // 10 seconds - tips list response be changed due to user replying to a question
    },
  });

  // Return data
  return {
    data: data !== undefined ? data : [],
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
